'use client';
import { Input, Label } from '@ethsign/ui';
import { shortenWalletAddress } from '@ethsign/utils-web';
import classNames from 'classnames';
import React from 'react';

import { SignPreviewIcon } from '@/components';
export const SignInputTab = ({
  address,
  value,
  onChange
}: {
  address?: string;
  value?: string;
  onChange: (v: string) => void;
}) => {
  return (
    <div>
      <Label>Type</Label>
      <Input
        size={'md'}
        className="flex-1 mt-[6px]"
        placeholder="Type your name here"
        max={50}
        value={value}
        onChange={(e) => onChange(e.target.value?.slice(0, 50))}
      />
      <div className="mt-[20px] border border-gray-200 rounded-[8px] p-[16px]">
        <div className="text-sm font-medium text-tangerine-500">EthSigned By: </div>
        <div
          className={classNames(['text-md font-medium break-all'], {
            'text-gray-900': !!value,
            'text-gray-500': !value
          })}
        >
          {value ? <span className={'font-euphoriaRegular text-[24px]'}>{value}</span> : 'Your name here'}
        </div>
        <div className="text-xs text-gray-600 max-w-[396px] break-all">{address}</div>
      </div>
    </div>
  );
};

export const SignPreview = ({ src, address }: { src: string; address?: string }) => {
  return (
    <div className="flex">
      <div className="flex-[0_0_15px] p-[10px]">
        <SignPreviewIcon />
      </div>
      <div className="flex flex-col">
        <div className="text-sm font-medium text-tangerine-500">EthSigned By: </div>
        <div className="text-md font-medium text-gray-900 flex-1 flex items-center">
          <img src={src} alt="" height={'100%'} width={'auto'} className={'max-h-[32px] object-contain'} />
        </div>
        <div className="text-sm font-medium text-gray-300">{shortenWalletAddress(address!, 'shorter')}</div>
      </div>
    </div>
  );
};

export enum SignatureStyleTypeEnum {
  TYPE = 'TYPE',
  UPLOAD = 'UPLOAD',
  DRAW = 'DRAW',
  STYLES = 'STYLES'
}
